import { AppState } from 'acscp/store';
import { userIsLoggedIn } from 'acscp/store/helpers/authHelper';
import { RouteComponentProps } from 'react-router';

interface AuthPageStateProps {
    isLoggedIn: boolean;
    isGuestLogin: boolean;
    stateAllowsGuestAccess: boolean;
    isNonJetPortalUser: boolean;
}

export type AuthPageProps = RouteComponentProps<any> & AuthPageStateProps;

export function mapStateToAuthPageProps(state: AppState): AuthPageStateProps {
    return {
        isLoggedIn: userIsLoggedIn(state.auth),
        isGuestLogin: state.auth.guestLogin,
        stateAllowsGuestAccess: (!ENABLE_CREATE_ACCOUNT || !USE_MOBILE_APP_LOGIN_PAGE) && state.auth.sharingTokens.length > 0,
        isNonJetPortalUser: state.auth.isNonJetPortalUser,
    };
}
